var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddlearningcentreicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18.741,
    viewBox: "0 0 19 18.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6335",
    "data-name": "Group 6335",
    transform: "translate(-5147 1026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6332",
    "data-name": "Group 6332",
    transform: "translate(3918.042 -964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3241",
    "data-name": "Group 3241",
    transform: "translate(2780.007 -488.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M-1542.542,438.487a8.576,8.576,0,0,0-3.911.505,8.579,8.579,0,0,0-3.912-.505.784.784,0,0,0-.684.786v6.19a.779.779,0,0,0,.856.786,6.325,6.325,0,0,1,3.4.522.753.753,0,0,0,.7-.016,6.727,6.727,0,0,1,3.371-.506.778.778,0,0,0,.857-.786v-6.19A.784.784,0,0,0-1542.542,438.487Zm-6.966,6.147v-4.608a6.459,6.459,0,0,1,2.284.351v4.534a8.589,8.589,0,0,0-2.284-.277Zm6.109,0a8.766,8.766,0,0,0-2.284.277v-4.534a6.48,6.48,0,0,1,2.284-.351Z",
    transform: "translate(0 -1.344)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M-1546.965,435.213a.713.713,0,0,0,1.027,0l3.254-3.339a2.9,2.9,0,0,0,0-4.022,2.724,2.724,0,0,0-3.768-.145,2.723,2.723,0,0,0-3.767.145,2.9,2.9,0,0,0,0,4.022Z",
    transform: "translate(-0.003 -0.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M-1530.979,427.716c-.058-.016.355.065-4.95-.938a.692.692,0,0,0-.819.682V430.8a2.08,2.08,0,0,0-.715-.127,2.1,2.1,0,0,0-2.1,2.107,2.1,2.1,0,0,0,2.1,2.107,2.1,2.1,0,0,0,2.1-2.107V428.3l3.518.665v2.765a2.08,2.08,0,0,0-.714-.126,2.1,2.1,0,0,0-2.1,2.107,2.1,2.1,0,0,0,2.1,2.107,2.1,2.1,0,0,0,2.1-2.107c0-.041,0-5.287,0-5.327a.691.691,0,0,0-.512-.665Zm-6.483,5.785a.717.717,0,0,1-.714-.719.716.716,0,0,1,.714-.718.717.717,0,0,1,.715.718A.717.717,0,0,1-1537.462,433.5Zm4.9.926a.718.718,0,0,1-.715-.718.718.718,0,0,1,.715-.719.717.717,0,0,1,.714.719A.716.716,0,0,1-1532.562,434.427Z",
    transform: "translate(-1.583 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013",
    transform: "translate(1239.958 -52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1006",
    "data-name": "Rectangle 1006",
    width: 2,
    height: 8,
    transform: "translate(3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1007",
    "data-name": "Rectangle 1007",
    width: 2,
    height: 8,
    transform: "translate(8 3) rotate(90)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddlearningcentreicon);
export default __webpack_public_path__ + "static/media/addlearningcentreicon.17b1a99f093a286daf499e2fd9c8e055.svg";
export { ForwardRef as ReactComponent };